import React, { createContext, useContext, useState } from 'react';

// Criação do contexto
const DashboardContext = createContext();

// Provedor do contexto
export const DashboardProvider = ({ children }) => {
  const [selectedId, setSelectedId] = useState(null);

  return (
    <DashboardContext.Provider value={{ selectedId, setSelectedId }}>
      {children}
    </DashboardContext.Provider>
  );
};

// Hook para usar o contexto
export const useDashboard = () => {
  return useContext(DashboardContext);
};